import {
	Box,
	Button,
	Group,
	Modal,
	Stack,
	Text,
	ThemeIcon,
	Title,
} from "@mantine/core";
import { IconClock, IconShieldCheck } from "@tabler/icons-react";

/** Modal info: akun sudah terdaftar tetapi belum diverifikasi admin. */
export function PendingVerificationModal({
	opened,
	onClose,
}: {
	opened: boolean;
	onClose: () => void;
}) {
	return (
		<Modal
			opened={opened}
			onClose={() => onClose()}
			centered
			withCloseButton={false}
			radius="lg"
			padding="xl"
		>
			<Stack align="center" gap="md">
				<ThemeIcon size={64} radius="xl" variant="light" color="orange">
					<IconClock size={32} />
				</ThemeIcon>
				<Title order={3} ta="center">
					Menunggu Verifikasi Admin
				</Title>
				<Text c="dimmed" ta="center" fz="sm">
					Akun kamu sudah terdaftar, tetapi belum diverifikasi oleh
					administrator. Silakan hubungi admin untuk mengaktifkan akun kamu.
				</Text>
				<Box
					p="sm"
					style={{
						background: "var(--mantine-color-orange-0)",
						borderRadius: "var(--mantine-radius-md)",
						border: "1px solid var(--mantine-color-orange-3)",
						width: "100%",
					}}
				>
					<Group gap="xs" justify="center">
						<IconShieldCheck size={16} color="var(--mantine-color-orange-6)" />
						<Text fz="xs" c="orange.7" fw={500}>
							Admin akan memverifikasi akun kamu secepatnya
						</Text>
					</Group>
				</Box>
				<Button
					fullWidth
					radius="md"
					variant="light"
					color="orange"
					onClick={() => onClose()}
				>
					Mengerti
				</Button>
			</Stack>
		</Modal>
	);
}
